var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h3 class=\"modal-title\" id=\"modal-title\">\nSnapshot: <span style=\"color:rebeccapurple;font-weight:400\">{{snapshot.snapshot}}</span>\n</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"snapshots-modal-table\">\n<table ts-wrapper class=\"table table-striped table-hover\" ts-per-page-default=\"10\" ts-display-filtering=\"false\">\n<thead>\n<tr>\n<th ts-criteria=\"name\">Index Name</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in indices\" ts-repeat ts-hide-no-data>\n<td>{{data.name}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Close</button>\n</div>";
var id1="containers/cluster-snapshots-details/cluster-snapshots-details-modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/containers/cluster-snapshots-details/cluster-snapshots-details-modal.html
// module id = 1313
// module chunks = 0